import { useIsMobile } from '@/hooks/useIsMobile';
import { Box, LinearProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

const CarouselBanner = ({ banners, fetching, maxHeight, disabled, hideBullets }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const { isMobile } = useIsMobile();

  if (fetching) {
    return <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, width: '100%' }} />;
  }

  const images = banners
    ?.sort((a, b) => a.order - b.order)
    ?.map(({ image, imageMobile }) => ({
      original: isMobile ? imageMobile : image,
      originalHeight: 10,
    }));

  const imageUrl = banners?.find((_, index) => index === activeSlide)?.url;

  const onClick = () => {
    const link = document.getElementById('cakto-carousel-banner-link');
    if (!disabled) {
      link.click();
    }
  };

  return (
    <Box sx={{ marginBottom: 2, position: 'relative' }}>
      <style>
        {`
          .image-gallery-content .image-gallery-slide .image-gallery-image {
            cursor: ${disabled ? 'default !important' : 'pointer'};
            object-fit: contain !important;
            maxHeight: ${maxHeight ? null : '300px !important'};
          }
        `}
      </style>

      <ImageGallery
        items={images || []}
        autoPlay
        autoPlayInterval={10000}
        slideInterval={10000}
        showPlayButton={false}
        showThumbnails={false}
        showBullets={false}
        showNav={false}
        showFullscreenButton={false}
        infinite
        onSlide={setActiveSlide}
        onClick={onClick}
      />

      {!disabled && (
        <a
          style={{ display: 'none' }}
          id="cakto-carousel-banner-link"
          data-testid="cakto-discord"
          href={imageUrl}
          target="_blank"
          rel="noreferrer"
        >
          link
        </a>
      )}

      {!hideBullets && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '15px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {banners?.map((_, index) => (
            <Box
              key={index}
              data-testid="bullet-indicator"
              sx={{
                width: activeSlide === index ? '20px' : '6px',
                height: '6px',
                backgroundColor: activeSlide === index ? '#36B37E' : '#333E49',
                borderRadius: activeSlide === index ? '3px' : '50%',
                margin: '0 5px',
                transition: 'background-color 0.3s ease',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

CarouselBanner.propTypes = {
  banners: PropTypes.array,
  fetching: PropTypes.bool,
  maxHeight: PropTypes.bool,
  disabled: PropTypes.bool,
  hideBullets: PropTypes.bool,
};

export default CarouselBanner;
